import { Component, EventEmitter, OnInit, Type, Output } from '@angular/core';
import { FormFieldBaseComponent } from '../form-field-base/form-field-base.component';
import { FormFieldPropertyEnum } from '../../../models/form-builder/form-field-property-enum.model';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FlexibleSelectionFieldService } from '../../../services/flexible-selection-field.service';

@Component({
    selector: 'app-flex-field-buttons-form-field',
    templateUrl: './flex-field-buttons-form-field.component.html',
    styleUrl: './flex-field-buttons-form-field.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FlexFieldButtonsFormFieldComponent,
            multi: true
        }
    ],
    standalone: false
})
export class FlexFieldButtonsFormFieldComponent extends FormFieldBaseComponent implements OnInit {
    @Output() onInit = new EventEmitter();
    @Output() onPropertyUpdated = new EventEmitter();

    private readonly formFieldProperties: string[] =
        [
            FormFieldPropertyEnum.HELP_TEXT,
            FormFieldPropertyEnum.SELECT_OPTIONS,
            FormFieldPropertyEnum.INSTRUCTIONS_TEXT,
            FormFieldPropertyEnum.FLEX_FIELD_BUTTONS
        ];

    private showSelectFilterOptionMsg: boolean = false;

    constructor(private flexibleSelectionFieldService: FlexibleSelectionFieldService){
        super();
    }

    public ngOnInit(): void {
        let hshProperties = this.getProperties();

        this.onInit.emit(hshProperties);

        if(this.formField.requireFormGridFilter)
            this.showSelectFilterOptionMsg = true;
    }

    public get IsShpFilteringEnabled() {
        return this.formField.requireFormGridFilter;
    }

    public get ShowSelectFilterOptionMsg() {
        return this.showSelectFilterOptionMsg;
    }

    public getProperties() {
        let hshProperties =
        {
            component: this,
            formField: this.formField,
            properties: this.formFieldProperties,

            propertyUpdateRequired: true
        };

        return (hshProperties);
    }

    public handleApply() {
        this.flexibleSelectionFieldService.applyFlexFieldValuesOnSiteHomePage();
        this.showSelectFilterOptionMsg = false;
    }

    public handleClear() {
        this.flexibleSelectionFieldService.clearFlexFieldValuesOnSiteHomePage();
        this.showSelectFilterOptionMsg = true;
    }

    public getFormFieldClass(): Type<any> {
        throw new Error('Method not implemented.');
    }

}
